// import { ApiKeysCard } from '@components/Settings/ApiKeysCard';
import ColorBlindModeSelectorCard from '@components/Settings/ColorBlindModeCard';
import LanguageCard from '@components/Settings/LanguageCard';
import PasswordChangeCard from '@components/Settings/PasswordChangeCard';
import ViewerEnvironmentCard from '@components/Settings/ViewerEnvironmentCard';
import Header from '@components/Shared/Layout/Header';
import { Box } from '@mui/material';

const SettingsPage = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <Header />
      <ColorBlindModeSelectorCard />
      <ViewerEnvironmentCard />
      <LanguageCard />
      <PasswordChangeCard />
      {/* <ApiKeysCard /> */}
    </Box >
  );
};

export default SettingsPage;
